import script from "./ConfiguracionesEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguracionesEvento.vue?vue&type=script&setup=true&lang=js"

import "./ConfiguracionesEvento.vue?vue&type=style&index=0&id=678091ac&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-678091ac"]])

export default __exports__